import React from 'react';
import { LogRow } from '@go-client/components/UserRecords/UserActionLog';

type LogLoaderProps = {
  isLoading: boolean;
  isError: boolean;
  fields: { [key: string]: any };
};

export const LogLoader: React.FC<LogLoaderProps> = ({ isLoading, isError, fields }) => {
  if (isLoading) {
    return (
      <tr>
        <td colSpan={2} aria-colspan={2} className="text-center">
          <p className="text-grey-darker">Loading data...</p>
        </td>
      </tr>
    );
  }

  if (isError) {
    return (
      <tr>
        <td colSpan={2} aria-colspan={2} className="text-center">
          <p className="text-grey-darker">There was an error trying to load the data.</p>
        </td>
      </tr>
    );
  }

  return (
    <>
      {Object.keys(fields).map((key, i) => (
        <LogRow field={key} value={fields[key]} key={i} />
      ))}
    </>
  );
};
